import React from 'react';
import './main.less';

import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import { isRequired, isSelected } from '../../../shared/form/validation';

import { enum as campaigns } from '../../../../../../../enums/banner-campaigns';

function PublicationEditor({ intl, bannerContentsLookup, ...props }) {
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit banner publication')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div>
						<Field
							className='banners-publication-editor-field'
							name='title'
							component={InputField}
							validate={[isRequired]}
							placeholder={intl('Publication title')}
						/>
						<div className='banners-publication-editor-field'>
							<Field
								name='campaign'
								component={SelectField}
								validate={[isSelected]}
								searchable={false}
								options={campaigns.map((c) => ({ value: c.id, label: c.title }))}
								placeholder={intl('Campaign')}
							/>
						</div>
						<div className='banners-publication-editor-field'>
							<Field
								name='content'
								component={SelectField}
								validate={[isSelected]}
								searchable={true}
								options={bannerContentsLookup}
								placeholder={intl('Сontent')}
							/>
						</div>
						<Field
							className='banners-publication-editor-field'
							name='display_at'
							type='datetime-local'
							format={v => v && moment(v).format('YYYY-MM-DDTHH:mm:ss')}
							component={InputField}
							placeholder={intl('Display at')}
						/>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/banners/publications'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError')
		// -----------------------------------------
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(PublicationEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/publication/editor/main.js